import React from 'react'
import { useHistory, useLocation } from 'react-router'
import { Link as RouterLink } from 'react-router-dom'
import { signIn } from 'actions/auth'
import { useDispatch } from 'react-redux'
import { Grid, Button, Paper, Box, Typography, Link } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import SixpenceLogo from '../img/sixpence-logo.svg'
import LoginBackgroundImage from '../img/login-cul-de-sac.png'
import GoogleAuthenticate from 'components/Authenticate/GoogleAuthenticate'
import FacebookAuthenticate from 'components/Authenticate/FacebookAuthenticate'
import OrDivider from 'components/Authenticate/OrDivider'
import Email from 'components/Fields/Email'
import Password from 'components/Fields/Password'
import { FormProvider } from 'react-hook-form'
import useFormExpanded from 'hooks/useFormExpanded'
import { setNotification } from 'actions/status'

const useStyles = makeStyles(({ spacing }) => ({
  root: { height: '100vh' },
  image: {
    backgroundImage: `url(${LoginBackgroundImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  },
  logo: {
    display: 'block',
    margin: `${spacing(6)}px auto`,
  }
}))

const LoginPage = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const location = useLocation()
  const history = useHistory()

  const handleSignInSuccess = () => {
    const priorLocation = location.state?.from
    history.replace(priorLocation || '/')
  }

  function handleSignIn({ email, password }) {
    dispatch(signIn(email, password)).then(
      () => { handleSignInSuccess() }
    ).catch(({ data: { errors } }) => {
      dispatch(setNotification('error', errors[0]))
    })
  }

  const formMethods = useFormExpanded()
  const { handleSubmit } = formMethods

  return (
    <Grid container className={classes.root}>
      <Grid item xs={false} sm={4} md={7} className={classes.image} />
      <Grid item xs={12} sm={8} md={5} elevation={6} component={Paper} square>
        <Box mx={8} my={4}>
          <img className={classes.logo} alt='sixpence logo' src={SixpenceLogo}/>
          <Typography align='center' variant='h4' component='h1'>Log In</Typography>
          <FormProvider { ...formMethods }>
            <form onSubmit={handleSubmit(handleSignIn)}>
              <Email autoFocus fullWidth margin='normal' />
              <Password fullWidth margin='normal' />
              <Button type='submit' fullWidth color='primary' variant='contained'>Log In</Button>
              <Link variant='body2' component={RouterLink} to='/forgot-password'>Forgot Password?</Link>
            </form>
          </FormProvider>

          <OrDivider />

          <GoogleAuthenticate type='signIn' onSuccessCallback={handleSignInSuccess} />
          <FacebookAuthenticate type='signIn' onSuccessCallback={handleSignInSuccess} />
        </Box>
      </Grid>
    </Grid>
  )
}

export default LoginPage
